import { LANGS } from './utils/constants';
import NearMeIcon from '@material-ui/icons/NearMe';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';

class BasicLangChip extends React.Component {

    render() {

        const { label, classes, defaultLang, isReadOnly, viewLang, onClick, deprecated, deleted, compact,
            onDelete, id, invalid, additionalIcon, highlight, additionalAvatar } = this.props;
            
        const displayLang = viewLang && label && label[viewLang] ?
            viewLang
            :
            label && label[defaultLang] ?
                defaultLang
                :
                label && label["und"] ?
                    "und"
                    :
                    defaultLang;

        const isLongLang = displayLang.length > 2;
        const style = isLongLang ?
            {
                width: '40px', borderRadius: '16px',
                ...(viewLang && displayLang !== viewLang) ? { backgroundColor: '#FF6F00' } : { backgroundColor: '#01579B' }
            }
            :
            {
                ...(viewLang && displayLang !== viewLang) ? { backgroundColor: '#FF6F00' } : { backgroundColor: '#01579B' }
            };
        const text = label && label[displayLang] ? (
            Array.isArray(label[displayLang]) ?
                [...label[displayLang]].sort().join(" AND ")
                :
                label[displayLang]
        )
            :
            id;

        return (
            <Chip
                data-test={invalid ? "invalid-link" : "link"}
                data-status={
                    deleted ?
                        "deleted"
                        :
                        deprecated ?
                            "deprecated"
                            :
                            invalid ?
                                "invalid"
                                :
                                highlight ?
                                    "highlight"
                                    :
                                    null}
                color="primary"
                className={compact ? classes.compactChip : classes.chip}
                style={
                    {
                        ...(highlight) && { backgroundColor: '#a0a0a0' },
                        ...(invalid) && { backgroundColor: '#FF6F00' },
                        ...(deprecated) && { backgroundColor: '#FF6F00' },
                        ...(deleted) && { backgroundColor: '#DD2C00' }
                    }
                }
                avatar={<Tooltip title={LANGS[displayLang][defaultLang] ?
                    LANGS[displayLang][defaultLang]
                    :
                    LANGS[displayLang]["en"]}>
                    <Avatar style={style}>{displayLang === "und" ? "None" : displayLang}</Avatar>
                </Tooltip>}
                onClick={onClick}
                onDelete={!isReadOnly && onDelete ? onDelete : null}
                label={
                    <Tooltip
                        title={id}
                        PopperProps={{
                            "data-test": "chip-tip"
                        }}>
                        {additionalIcon ?
                            <span data-test="chip-text">
                                <span style={{
                                    display: 'inline-block',
                                    transform: 'translateY(2px)'
                                }}>
                                    {additionalAvatar}
                                </span>
                                <span style={{
                                    display: 'inline-block',
                                    transform: 'translateY(-4px)',
                                    paddingTop: '5px',
                                    paddingLeft: '4px'
                                }}>
                                    {text}
                                </span>
                            </span>
                            :
                            <span data-test="chip-text">{text}</span>
                        }
                    </Tooltip>
                } />
        );
    }
}

BasicLangChip.defaultProps = {
    invalid: false,
    highlight: false,
    deleted: false,
    deprecated: false,
    compact: false,
    additionalAvatar: <NearMeIcon data-test="near-me" fontSize="small" />
};

BasicLangChip.propTypes = {
    additionalAvatar: PropTypes.object,
    highlight: PropTypes.bool,
    deprecated: PropTypes.bool,
    id: PropTypes.string.isRequired,
    additionalIcon: PropTypes.bool,
    deleted: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    compact: PropTypes.bool,
    onClick: PropTypes.func,
    onDelete: PropTypes.func,
    label: PropTypes.object,
    invalid: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    classes: PropTypes.object
};

export default withStyles(styles)(BasicLangChip);